import React from 'react';

export function Management() {
  return <div>Management.Container</div>;
}
